namespace('compass.hotel');


compass.hotel.PriceSavingsExplanationWidget = compass.defineWidget(function PriceSavingsExplanationWidget(options) {
	var me = this;
	var d = jQuery.dom.getContext(this);
	var _settings = options;
	
	this.render = function (widgetElem) {

		var priceSavingsExplanationDialogContent = d.div({className: 'PriceSavingsExplanation'},
			d.h1({className: 'priceSavingsExplanationHeader'}, "Rate Comparison"),
			d.div({className: 'priceSavingsExplanationDivider'}),
			d.div({className: 'priceSavingsExplanationText'}, "On average, event rates are " + (_settings.priceSavingsPercent * 100) + "% lower than best available retail rates.")
		);
		
		d.dialog({
			contents: priceSavingsExplanationDialogContent,
			centerOnView: true,
			showParent: true
		});
	};

}, {
	priceSavingsPercent: 0.3
});